/**
 * shadcn/ui's class helper (components import `cn` from "@/lib/utils").
 * A tiny clsx equivalent + tailwind-merge, so we don't need another dependency.
 */
import { twMerge } from "tailwind-merge";

export type ClassValue = string | number | null | undefined | false | ClassValue[] | Record<string, boolean | null | undefined>;

function flatten(value: ClassValue, out: string[]): void {
  if (value === null || value === undefined || value === false || value === "") return;
  if (typeof value === "string" || typeof value === "number") {
    out.push(String(value));
  } else if (Array.isArray(value)) {
    for (const v of value) flatten(v, out);
  } else {
    for (const [key, on] of Object.entries(value)) if (on) out.push(key);
  }
}

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  for (const v of inputs) flatten(v, out);
  return twMerge(out.join(" "));
}
